//Javascript for WECAN license filter
app.LicenseFilter = (
    function () {
        var filter = {
            Init: function () {
                app.LicenseFilter.GetSchwifty();
                $(document).on("component-bind-edit-mode-complete", function () {
                    app.LicenseFilter.GetSchwifty();
                });
            },
            GetSchwifty: function () {
                $("[data-license-classification-filter]").on("change", function () {
                    //Get selected classification from filter dropdown
                    var selected = $(this).find(":selected").attr("value");
                    //Get the target
                    var targetName = $(this).data("license-classification-filter");
                    //Check for dropdown target
                    var targetElement = $("[Name='" + targetName + "']");
                    var optgroups = $(targetElement).find("optgroup");

                    //If dropdown then...
                    if (optgroups.length) {
                        for (var i = 0; i < optgroups.length; i++) {
                            if (selected != null && selected != "undefined" && selected != "") {
                                $(targetElement).prop('selectedIndex', 0);
                                if ($(optgroups[i]).attr("label") === selected) {
                                    $(optgroups[i]).show();
                                }
                                else {
                                    $(optgroups[i]).hide();
                                }
                            }
                            else {
                                $(optgroups[i]).show();
                            }
                        }
                    }
                    //If select many then...
                    else {
                        targetElement = $("fieldset#fst" + targetName);
                        var selectgroups = $(targetElement).find(".select-many-group-header");
                        for (var i = 0; i < selectgroups.length; i++) {
                            if (selected != null && selected != "undefined" && selected != "") {

                                if ($(selectgroups[i]).text() === selected) {
                                    $(selectgroups[i]).closest("[data-role='select-many-group']").show();
                                }
                                else {
                                    $(selectgroups[i]).closest("[data-role='select-many-group']").hide();
                                }
                            }
                            else {
                                $(selectgroups[i]).closest("[data-role='select-many-group']").show();
                            }
                        }
                    }
                });
            }
        }
        return filter;
    }()
);